import React, { useState } from "react";
import {
  Typography,
  Card,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  FormControlLabel,
  Checkbox,
  Box,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";

function Results({ data, theme }) {
  const [showOnlyErrors, setShowOnlyErrors] = useState(false);

  if (!data?.length > 0) {
    return null;
  }

  const filteredData = showOnlyErrors ? data.filter((row) => row.error) : data;

  return (
    <Card sx={{ padding: 2 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography variant="h6">
          {showOnlyErrors
            ? `Errori (${filteredData.length})`
            : `Risultati (${data.length})`}
        </Typography>
        {data.some((row) => row.error) && (
          <FormControlLabel
            control={
              <Checkbox
                checked={showOnlyErrors}
                onChange={(e) => setShowOnlyErrors(e.target.checked)}
                color="error"
              />
            }
            label="Mostra solo errori"
          />
        )}
      </Box>
      <TableContainer component={Paper} sx={{ maxHeight: 300, height: 500 }}>
        <Table
          stickyHeader
          aria-label="simple table"
          sx={{ minWidth: 500 }} // Set min width for the table
        >
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  padding: "8px",
                  width: "120px", // Fixed width for the first column
                }}
              >
                Numero riga
              </TableCell>
              <TableCell sx={{ padding: "8px" }} align="left">
                Collaboratore
              </TableCell>
              <TableCell sx={{ padding: "8px" }} align="left">
                Stato
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData.length > 0 ? (
              filteredData.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{ padding: "8px", width: "100px" }} // Fixed width for the first column
                  >
                    {row.row}
                  </TableCell>
                  <TableCell align="left" sx={{ padding: "8px" }}>
                    {row.reference}
                  </TableCell>
                  <TableCell
                    align="left"
                    sx={{
                      padding: "8px",
                      color: row.error
                        ? theme.palette.error.main
                        : theme.palette.success.main,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {row.error ? (
                      <>
                        <ErrorIcon
                          sx={{ marginRight: "8px" }}
                          style={{ color: theme.palette.error.main }}
                        />
                        {row.message}
                      </>
                    ) : (
                      <>
                        <CheckCircleIcon
                          sx={{ marginRight: "8px" }}
                          style={{ color: theme.palette.success.main }}
                        />
                        {row.message}
                      </>
                    )}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={3} align="center">
                  {showOnlyErrors
                    ? "Nessun errore trovato"
                    : "Nessun dato disponibile"}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
}

export default Results;
